import React from 'react';
import { ViewabilityElement } from 'mm-ui-components';
import { sendPageView } from 'mm-client-core';
import { useSelector } from 'react-redux';
import { ArticlePageViewParameters, ConfigPageViewParameters } from '../../templates/utils/articleComponent.utils';
import {
    getAdSlots,
    getEdition,
    getLanguage,
    getPageType,
    getSiteName,
    getAmpDfpProperty,
    getAuthors,
    getMainCategory,
    getAutoTags,
} from '../../store/config/config.selectors';
import { getCountryCode } from '../../templates/templates.utils';
import { getUniqueTagList } from '../../store/config/config.utils';

interface ArticleUrlProp {
  articleURL: string;
}

const sendCustomEvent = (eventName: string, eventData: any) => {
  const customEvent = new CustomEvent(eventName, { detail: eventData });
  window.dispatchEvent(customEvent);
};

type ArticlePageViewEventProps = ArticlePageViewParameters & ArticleUrlProp
export const ArticlePageViewEvent: React.FunctionComponent<ArticlePageViewEventProps> = props => {
  const {
    children,
    ownerUsername,
    authorsUsernames,
    articleTitle,
    articleIntro,
    articleAuthor,
    articleContentCount,
    articleId,
    articlePublicationTime,
    articleTemplate,
    articleWordCount,
    articleMainCategory,
    channels,
    commercialTags,
    contentTags,
    dfpCategory,
    mainMedia,
    articleURL,
    createdAt,
    updatedAt,
    isSlideshow,
    mainCategoryEmbed,
    numberOfArticleOnPage,
    topic,
    vertical,
    experiments,
    seoTitle,
    allAuthors,
  } = props;
  const siteName = useSelector(getSiteName);
  const language = useSelector(getLanguage);
  const pageType = useSelector(getPageType);
  const property = useSelector(getEdition);
  const adSlots = useSelector(getAdSlots);
  const dfpProperty = useSelector(getAmpDfpProperty);
  const authorNames = useSelector(getAuthors)?.map(author => author.name);
  const mainCategorySlug = useSelector(getMainCategory)?.slug || '';
  const edition = useSelector(getEdition);
  const autoTags = useSelector(getAutoTags) || [];
  const isSIMX = edition === 'si_mexico';

  const sendPageViewForArticle = React.useCallback(() => {
    const pageParameters: ArticlePageViewParameters & ArticleUrlProp & ConfigPageViewParameters = {
      ownerUsername,
      authorsUsernames,
      articleTitle,
      articleAuthor,
      articleContentCount,
      articleId,
      articlePublicationTime,
      articleTemplate,
      articleWordCount,
      articleMainCategory,
      channels,
      commercialTags,
      contentTags,
      dfpCategory,
      mainMedia,
      siteName,
      language,
      pageType,
      property,
      adSlots,
      countryCode: getCountryCode(),
      dfpProperty,
      articleURL,
      createdAt,
      updatedAt,
      isSlideshow,
      mainCategoryEmbed,
      numberOfArticleOnPage,
      vertical,
      topic,
      articleIntro,
      experiments,
      seoTitle,
    };
    try {
      if (window.location.href !== articleURL) {
        window.history.pushState(null, 'change URL', articleURL);
      }
    } catch (e) {
      console.log('finite scroll error', e);
    }

    sendCustomEvent('finiteScrollEvent', { message: 'Next Article On finite Scroll', articleId });
    sendPageView(pageParameters, 'GTM data ready to GA finite scroll');
    try {
      // @ts-ignore
      if (window.pSUPERFLY && articleURL) {
        const articlePath = new URL(articleURL).pathname;
        // @ts-ignore
        window.pSUPERFLY.virtualPage({
          sections: `${articleMainCategory || pageType || ''}`,
          authors: `${allAuthors || articleAuthor}`,
          path: `${articlePath}`,
          title: `${articleTitle}`,
        });
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('chartbeat virtual page error', e);
    }
    try {
      // @ts-ignore
      if (window.permutive) {
        const permutiveEventVarsMX = {
          ...(authorNames?.length && { authors: authorNames }),
          ...(property && { brand: property }),
          ...(contentTags?.length && { keywords: contentTags }),
          ...(mainCategorySlug && { section: mainCategorySlug }),
          ...(articleTitle && { subtitle: articleTitle }),
          ...(contentTags?.length && { tags: getUniqueTagList(contentTags, autoTags) }),
        };

        const customTopicValue = topic || mainCategorySlug;

        const permutiveEventVars = {
          ...permutiveEventVarsMX,
          ...(customTopicValue && { default_topic: customTopicValue }),
          ...(vertical && { vertical }),
          ...(autoTags?.length && { auto_tags: autoTags.map(tag => tag.tag) }),
        };

        const permutiveEvent = isSIMX
            ? {
              page: {
                article: permutiveEventVarsMX,
              },
            }
            : {
              page: {
                article: permutiveEventVars,
              },
            };

        // @ts-ignore
        window.permutive.addon('web', JSON.stringify(permutiveEvent));
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('permutive error', e);
    }
  }, [ownerUsername, autoTags, authorsUsernames, articleTitle, articleAuthor, articleContentCount, articleId, articlePublicationTime, articleTemplate, articleWordCount, articleMainCategory, channels, commercialTags, contentTags, dfpCategory, mainMedia, siteName, language, pageType, property, adSlots, dfpProperty, articleURL, createdAt, updatedAt, isSlideshow, mainCategoryEmbed, numberOfArticleOnPage, vertical, topic, articleIntro, experiments, seoTitle, allAuthors, authorNames, mainCategorySlug, isSIMX]);

  return (
    <ViewabilityElement viewabilityCallback={sendPageViewForArticle}>
      {children}
    </ViewabilityElement>
  );
};
